/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Semantic reason stamped on a cancelled booking (distinct from slot cancellation).
 */
export type BookingCancellationReason = (typeof BookingCancellationReason)[keyof typeof BookingCancellationReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingCancellationReason = {
  student_cancelled: 'student_cancelled',
  lecturer_aborted: 'lecturer_aborted',
  oral_exam_attempt_failed: 'oral_exam_attempt_failed',
  student_no_show: 'student_no_show',
  lecturer_no_show: 'lecturer_no_show',
  platform_failure: 'platform_failure',
  teams_no_transcript: 'teams_no_transcript',
} as const;
